export class FormBenefits {
    constructor() {
        this.data = {};

        if (this.isActivated()){
            let formData = new FormData(document.getElementById('formBenefits'));
            for(let data of formData.entries()) {
                this.data[data[0]] = data[1];
            }
        }
    }

    isActivated(){
        if (document.querySelector('#benefitsForm')){
            return document.querySelector('#benefitsForm').checked;
        }
        return false;
    }
}